var exports = {
  "wx": "header__3vHp_p",
  "cP": "titleSection__o4LhU5",
  "Kk": "icon__aB337f",
  "DD": "title__J9xf03",
  "o1": "actions__wpr9bt",
  "p$": "emptyState__iTocdy",
  "vo": "emptyStateTitle__oFe8mq",
  "Li": "emptyStateDescription__0HAaHh",
  "aB": "emptyStateActions__vYNAlC",
};

module.exports = exports;
